import { projectsActions } from './slice';
import { Action } from 'redux-saga';
import { Project, ProjectSolutionType } from '../../models/project';
import { ProjectDTO } from '../../containers/BulkCreate/utils';
import { SiteLocationBuType } from './types';

export const fetchProjects = projectsActions.fetchProjects as (
  payload: string[],
) => Action;

export const fetchProjectsByStatus = projectsActions.fetchProjectsByStatus as (
  payload: string | string[],
) => {
  type: string;
  payload: string;
};

export const updateProjectSolution = projectsActions.updateProjectSolutions as (
  payload: ProjectSolutionType[],
) => Action;

export const setSelectedProject = projectsActions.setSelectedProject as (
  payload: string,
) => Action;

export const getProjectDetails = projectsActions.fetchProject as (payload: {
  id: string;
  refId?: boolean;
  dontAddToProjects?: boolean;
}) => Action;

export const getProjectActivityLog =
  projectsActions.fetchProjectActivityLog as (payload: {
    id: string;
  }) => Action;

export const setProjectToEdit = projectsActions.setProjectToEdit as (
  payload: unknown,
) => Action;

export const createProject = projectsActions.createNewProject as (
  payload: unknown,
) => Action;

export const updateProject = projectsActions.updateProject as (payload: {
  project: unknown;
  action?: ((data?: unknown) => Action) | Action;
}) => Action;

export const updateProjectsStatus =
  projectsActions.updateProjectsStatus as (payload: {
    projects: string[];
    status: string;
  }) => Action;

export const updateSingleProjectStatus =
  projectsActions.updateProjectStatus as (paylaod: {
    projectId: string;
    status: string;
  }) => Action;

export const addSolution = projectsActions.addSolution as (
  payload: Partial<ProjectSolutionType>,
) => Action;
export const addSolutions = projectsActions.addSolutions as (
  payload: ProjectSolutionType[],
) => Action;
export const removeSolution = projectsActions.removeSolution as (
  payload: string,
) => Action;
export const editSolution = projectsActions.editSolution as (
  payload: Partial<ProjectSolutionType>,
) => Action;

export const clearSolutions = projectsActions.clearSolutions as () => Action;
export const setSolutions = projectsActions.setSolutions as (
  payload: ProjectSolutionType[],
) => Action;
export const fetchSiteLocation = projectsActions.fetchSiteLocation as (
  payload: string,
) => Action;
export const changeBuForBulkCreateProject =
  projectsActions.changeBuForBulkCreateProject as (payload: {
    bu: string;
    onSuccess: (siteLocation: SiteLocationBuType) => void;
  }) => Action;
export const approveCrp = projectsActions.approveCrp as (payload: {
  projects: string[];
  partOfAnApprovedCrp: boolean;
  moveQualifiedToDraft: boolean;
}) => Action;

export const updatePartOfCrp = projectsActions.updatePartOfCrp as (payload: {
  projectIds: string[];
  fiscalYears: string[];
}) => Action;

export const updatePartOfApprovedCrp =
  projectsActions.updatePartOfApprovedCrp as (payload: {
    projectIds: string[];
    fiscalYears: string[];
  }) => Action;

export const archiveProjects = projectsActions.archiveProjects as (
  payload: string[],
) => Action;

export const deleteProjects = projectsActions.deleteProjects as (
  payload: string,
) => Action;

export const addToOnePlan = projectsActions.addToOnePlan as (
  payload: string,
) => Action;
export const createMSTeams = projectsActions.createMSTeams as (payload: {
  projectId: string;
  referenceId: string;
  projectName: string;
  isTesting: boolean;
  ownerEmail: string;
  link: string | null;
  members: {
    [key: string]: string;
  };
}) => Action;

export const setProjectsForBulk = projectsActions.setProjectsForBulk as (
  payload: string[],
) => Action;
export const fetchProjectsForBulk = projectsActions.fetchProjectsForBulk as (
  payload: string[],
) => Action;

export const UpdateProjectsBulk =
  projectsActions.updateProjectsBulk as (payload: {
    payload: Project[];
    history: History;
  }) => Action;

export const createProjectsBulk =
  projectsActions.createProjectsBulk as (payload: {
    projects: ProjectDTO[];
    history: History;
  }) => Action;
